const configuredUntil = import.meta.env.VITE_BACKGROUND_DB_WORK_PAUSED_UNTIL;
const MAX_TIMER_MS = 2_147_000_000;

export function backgroundDbWorkRefetchIntervalMs(
  normalIntervalMs: number,
): number {
  const resumeAtMs = Date.parse(configuredUntil?.trim() || "");
  if (!Number.isFinite(resumeAtMs)) return normalIntervalMs;
  const remainingMs = Math.max(0, resumeAtMs - Date.now());
  return remainingMs > 0
    ? Math.min(remainingMs + 250, MAX_TIMER_MS)
    : normalIntervalMs;
}
